import React from 'react'
import gql from 'graphql-tag'
import { Query, Mutation } from 'react-apollo'
import MomentModalLoading from '../momentCard/MomentModalLoading'

const momentQuery = gql`
  query MomentQuery($id: ID!) {
    Moment(id: $id) {
      id
      message
      momentAt
    }
  }
`

export const updateMomentMutation = gql`
  mutation UpdateMomentMutation(
    $id: ID!
    $message: String
    $momentAt: DateTime
  ) {
    updateMoment(id: $id, message: $message, momentAt: $momentAt) {
      id
      message
      momentAt
    }
  }
`

const UpdateMoment = ({ momentId, userId, children }) => (
  <Query query={momentQuery} variables={{ id: momentId }}>
    {({ loading, error, data }) => {
      if (loading) return <MomentModalLoading />
      return (
        <Mutation mutation={updateMomentMutation}>
          {updateMoment =>
            children({
              moment: data.Moment,
              onSaveMoment: values =>
                updateMoment({
                  variables: {
                    id: data.Moment.id,
                    ...values,
                  },
                }),
            })
          }
        </Mutation>
      )
    }}
  </Query>
)

export default UpdateMoment



// WEBPACK FOOTER //
// ./src/components/templates/updateMoment/UpdateMoment.js